// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Theme = require("../reason/common/Theme/Theme.bs.js");
var Utils = require("./Utils.bs.js");
var React = require("react");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var UseWindowSize = require("uikit/hooks/useWindowSize");

function getBreakpoint(px) {
  var match = Theme.Breakpoints.breakpoints;
  if (px >= match.xxl) {
    return "xxl";
  } else if (px >= match.xl) {
    return "xl";
  } else if (px >= match.lg) {
    return "lg";
  } else if (px >= match.md) {
    return "md";
  } else if (px >= match.sm) {
    return "sm";
  } else {
    return "xs";
  }
}

function useResponsive(xs, sm, md, lg, xl, xxl, param) {
  var windowSize = UseWindowSize.useWindowSize();
  var fallback = function (opt, fallbackVal) {
    if (opt !== undefined) {
      return opt;
    } else {
      return fallbackVal;
    }
  };
  var match = getBreakpoint(windowSize.width);
  return Core__Option.getOr(match === "md" ? fallback(md, sm) : (
                match === "sm" ? sm : (
                    match === "xl" ? fallback(fallback(fallback(xl, lg), md), sm) : (
                        match === "xs" ? Caml_option.some(xs) : (
                            match === "xxl" ? fallback(fallback(fallback(fallback(xxl, xl), lg), md), sm) : fallback(fallback(lg, md), sm)
                          )
                      )
                  )
              ), xs);
}

function eventTypeToJs($$event) {
  return $$event;
}

function useEventListenerOnDocument(useCaptureOpt, handler, $$event) {
  var useCapture = useCaptureOpt !== undefined ? useCaptureOpt : false;
  var savedHandler = React.useRef(undefined);
  React.useEffect((function () {
          Utils.React.setCurrentRef(savedHandler, handler);
        }), [handler]);
  React.useEffect((function () {
          var onEvent = function ($$event) {
            var handler = savedHandler.current;
            if (handler !== undefined) {
              return handler($$event);
            }
            
          };
          if (useCapture) {
            document.addEventListener($$event, onEvent, true);
          } else {
            document.addEventListener($$event, onEvent);
          }
          return (function () {
                    document.removeEventListener($$event, onEvent, true);
                  });
        }), [
        $$event,
        savedHandler,
        useCapture
      ]);
}

function usePrevious(value) {
  var ref = React.useRef(value);
  React.useEffect(function () {
        ref.current = value;
      });
  return ref.current;
}

exports.getBreakpoint = getBreakpoint;
exports.useResponsive = useResponsive;
exports.eventTypeToJs = eventTypeToJs;
exports.useEventListenerOnDocument = useEventListenerOnDocument;
exports.usePrevious = usePrevious;
/* Utils Not a pure module */
